import { GeoRegisterGroupParams } from "@aipb/gulliver/castor/model";
import { SPATIAL_FILTER_MAPPER } from './castor-mappers';
import { CastorMapper } from './mapper';

export class GeoRegisterGroupMapper implements CastorMapper<GeoRegisterGroupParams> {
  map(o: GeoRegisterGroupParams): { [p: string]: any } {
    if (!o) return {};

    const obj = {};

    obj['registers'] = JSON.stringify(o.registers);

    const params = {
      ...o,
      ...obj,
      ...SPATIAL_FILTER_MAPPER.map(o.spatialFilter)
    };

    delete params['spatialFilter'];

    return params;
  }
}

export const GEO_REGISTER_GROUP_MAPPER = new GeoRegisterGroupMapper();
